export const ResponsiveMixin = {
  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },
  computed: {
    isMobile() {
      return this.windowWidth < 960;
    },
  },
  beforeMount() {
    window.addEventListener("resize", this.handleResponsive);
  },
  methods: {
    handleResponsive() {
      this.windowWidth = window.innerWidth;
    },
  },
};
